class SocialBanner extends HTMLElement {
  constructor() {
    super();
    this.sliderWrapper = this.querySelector('[data-social-slider-wrapper]');
    $(document).ready(() => {
      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.sliderWidth = this.getSliderWidth(this.images);
            // this.scrollEnabled = true;
          } else {
            // this.scrollEnabled = false;
          }
        });
      }, { threshold: 0.1, rootMargin: '1800px' });
      this.observer.observe(document.querySelector('social-banner'));
      this.initialize();
    })
  }

  initialize() {
    this.slider = this.querySelector('[data-social-slider]');
    if (!this.slider) return;
    this.images = [...this.querySelectorAll('[data-social-image]')];
    this.clones = [];
    this.scrollEnabled = true;

    this.cloneImages(this.images);
    this.sliderWidth = this.getSliderWidth(this.images);

    this.scroll = {
      current: this.sliderWidth,
      target: this.sliderWidth
    };

    this.animate = this.animate.bind(this)

    this.addEventListeners();
    this.animate();
  }

  addEventListeners() {
    this.images.forEach(image => {
      image.addEventListener('touchstart', () => {
        const link = image.querySelector('.social-link');
        link.classList.add('active');
      }, { passive: true });

      image.addEventListener('touchend', () => {
        const link = image.querySelector('.social-link');
        link.classList.remove('active');
      }, { passive: true });

      image.addEventListener('mouseenter', (e) => {
        this.hoveredImage = image;
        this.scrollEnabled = false;

        this.mouse = {
          x: e.pageX,
          y: e.pageY
        }

        const link = image.querySelector('.social-link');
        link.classList.add('active');
      }, { passive: true });

      image.addEventListener('mouseleave', () => {
        this.hoveredImage = null;
        this.scrollEnabled = true;

        const link = image.querySelector('.social-link');
        this.linkPos = null;
        link.classList.remove('active');
      }, { passive: true });

      image.addEventListener('mousemove', (e) => {
        this.mouse = {
          x: e.pageX,
          y: e.pageY
        }
      }, { passive: true })
    });

    this.clones.forEach(image => {
      image.addEventListener('touchstart', () => {
        const link = image.querySelector('.social-link');
        link.classList.add('active');
      }, { passive: true });

      image.addEventListener('touchend', () => {
        const link = image.querySelector('.social-link');
        link.classList.remove('active');
      }, { passive: true });

      image.addEventListener('mouseenter', (e) => {
        this.hoveredImage = image;
        this.scrollEnabled = false;

        this.mouse = {
          x: e.pageX,
          y: e.pageY
        }

        const link = image.querySelector('.social-link');
        link.classList.add('active');
      }, { passive: true });

      image.addEventListener('mouseleave', () => {
        this.hoveredImage = null;
        this.scrollEnabled = true;

        const link = image.querySelector('.social-link');
        this.linkPos = null;
        link.classList.remove('active');
      }, { passive: true });

      image.addEventListener('mousemove', (e) => {
        this.mouse = {
          x: e.pageX,
          y: e.pageY
        }
      })
    }, { passive: true });

    this.sliderWrapper.addEventListener('wheel', (e) => {
      const { pixelX: x, pixelY: y } = NormalizeWheel(e);
      if (Math.abs(y) > 5) {
        return;
      } else if (Math.abs(x) > 0) {
        e.preventDefault();
        this.scroll.target += (x * 0.5);
      }
    });

    this.sliderWrapper.addEventListener('touchstart', (e) => {
      this.scrollEnabled = false;
      const { clientX: x, clientY: y } = e.touches[0];
      this.touchStart = {
        x,
        y
      }
    }, { passive: true });

    this.sliderWrapper.addEventListener('touchend', () => {
      this.scrollEnabled = true;
      this.touchStart = {};
    }, { passive: true })

    this.sliderWrapper.addEventListener('touchmove', (e) => {
      const { clientX, clientY } = e.touches[0];
      const x = this.touchStart.x - clientX;
      const y = this.touchStart.y - clientY;
      if (Math.abs(y) > 5) {
        return;
      } else if (Math.abs(x) > 0) {
        e.preventDefault();
        this.scroll.target += (x * 0.1);
      }
    });
  }

  cloneImages(images) {
    images.forEach(image => {
      const clone = image.cloneNode(true);
      clone.classList.add('clone');
      this.slider.appendChild(clone)
      this.clones.push(clone);
    })

    images.reverse().forEach(image => {
      const clone = image.cloneNode(true);
      clone.classList.add('clone');
      this.slider.prepend(clone)
      this.clones.push(clone);
    })
  }

  getSliderWidth(images) {
    let sliderWidth = 0;
    images.forEach(image => {
      var width = image.offsetWidth;
      var style = getComputedStyle(image);

      width += parseInt(style.marginLeft) + parseInt(style.marginRight);
      sliderWidth += width;
    })
    return sliderWidth;
  }

  animate() {
    if (this.hoveredImage && window.innerWidth >= 768) {
      this.activeSocial = this.hoveredImage.querySelector('.social-link')
      this.imagePos = this.hoveredImage.getBoundingClientRect();
      const x = (this.mouse.x - this.imagePos.x) - (this.activeSocial.clientWidth / 2);
      const y = (this.mouse.y - this.imagePos.y) - (this.activeSocial.clientHeight / 2);
      let xPos = x;
      let yPos = y;

      // if(
      //   (this.mouse.x - this.imagePos.x) <= (this.activeSocial.clientWidth / 2) + 40 ||
      //   this.mouse.x - this.imagePos.x >= this.imagePos.width - (this.activeSocial.clientWidth / 2) - 40 ||
      //   (this.mouse.y - this.imagePos.y) <= (this.activeSocial.clientHeight / 2) + 40 ||
      //   this.mouse.y - this.imagePos.y >= this.imagePos.height - (this.activeSocial.clientHeight / 2) - 40
      // ) {
      //   this.activeSocial.style.transition = 'transform 300ms ease-out';
      //   xPos = this.imagePos.width / 2 - this.activeSocial.clientWidth / 2;
      //   yPos = this.imagePos.height / 2 - this.activeSocial.clientHeight / 2;
      // } else {
      //   this.activeSocial.style.transition = 'none';
      // }

      this.activeSocial.style.transform = `translate(${xPos}px, ${yPos}px)`;
    }
    if (this.scroll.current <= 0) {
      this.scroll.current = this.sliderWidth
      this.scroll.target = this.sliderWidth + 10
    } else if (this.scroll.current >= this.sliderWidth * 2) {
      this.scroll.current = this.sliderWidth
      this.scroll.target = this.scroll.target - this.sliderWidth
    } else {
      if (this.scrollEnabled) {
        this.scroll.target += window.innerWidth >= 768 ? 0.5 : 0.2;
      }
    }

    this.scroll.current = lerp(this.scroll.current, this.scroll.target, 0.05);

    this.slider.style.transform = `translateX(${-1 * this.scroll.current}px)`;

    requestAnimationFrame(this.animate)
  }
}

customElements.define('social-banner', SocialBanner);

const PIXEL_STEP = 10;
const LINE_HEIGHT = 40;
const PAGE_HEIGHT = 800;

function NormalizeWheel(event) {
  let sX = 0, sY = 0,       // spinX, spinY
    pX = 0, pY = 0;       // pixelX, pixelY

  // Legacy
  if ('detail' in event) { sY = event.detail; }
  if ('wheelDelta' in event) { sY = -event.wheelDelta / 120; }
  if ('wheelDeltaY' in event) { sY = -event.wheelDeltaY / 120; }
  if ('wheelDeltaX' in event) { sX = -event.wheelDeltaX / 120; }

  // side scrolling on FF with DOMMouseScroll
  if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
    sX = sY;
    sY = 0;
  }

  pX = sX * PIXEL_STEP;
  pY = sY * PIXEL_STEP;

  if ('deltaY' in event) { pY = event.deltaY; }
  if ('deltaX' in event) { pX = event.deltaX; }

  if ((pX || pY) && event.deltaMode) {
    if (event.deltaMode == 1) {          // delta in LINE units
      pX *= LINE_HEIGHT;
      pY *= LINE_HEIGHT;
    } else {                             // delta in PAGE units
      pX *= PAGE_HEIGHT;
      pY *= PAGE_HEIGHT;
    }
  }

  // Fall-back if spin cannot be determined
  if (pX && !sX) { sX = (pX < 1) ? -1 : 1; }
  if (pY && !sY) { sY = (pY < 1) ? -1 : 1; }

  return {
    spinX: sX,
    spinY: sY,
    pixelX: pX,
    pixelY: pY
  };
}